import React from 'react';
import { ComponentConfig } from '@measured/puck';
import { ReduxSelectorProps } from '../../services/constants';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import { PaddingProps, paddingFields } from '../../puck/reusable-props/padding';
import CustomTooltip from '../../../components/common/tooltip';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { boxShadows } from '../../../page-builder/puck/reusable-props/options';

export type ReturnButtonProps = {
  ReturnButton: string;
  border: IBorderValueProps;
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const ReturnButton = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<ReturnButtonProps> => {
  return {
    label: (
      <CustomTooltip title="ReturnButton">
        <span>Return Button</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ReturnButton: {
        ...QuillTextEditor('Content').content,
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
    },
    defaultProps: {
      ReturnButton:
        '<p style="line-height:1.5;"><span style="font-size: 16px;">Return to Store</span></p>',
      showComponent: ['desktop', 'tablet', 'mobile'],
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      ...borderProps,
      boxShadow: 'none',
    },
    render: ({
      margin,
      ReturnButton,
      padding,
      boxShadow,
      showComponent,
      editMode,
      border,
    }) => {
      const storeData = useAppSelector(state => state.store.storeData);
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const state = useAppSelector(state => state);
      const newInterpolation = getQuillEditorText(ReturnButton, state);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType),
              }}
              className={`${border?.borderStyle?.[currentDeviceType]} ${boxShadow}  text-editor-content `}>
              <a
                href={storeData?.ShopURL ? `https://${storeData.ShopURL}` : '/'}
                type="button"
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: newInterpolation }}
              />
            </div>
          )}
        </>
      );
    },
  };
};
